import request from '@/api/request.js';

// 文件资料列表
export const getCmsDocumentListPage = (data) => {
    return request({
        url: '/cms/adm/cmsDocument/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加文件资料
export const addCmsDocument = (data) => {
    return request({
        url: '/cms/adm/cmsDocument/addCmsDocument',
        method: 'post',
        type: 'json',
        data
    })
}

// 编辑文件资料
export const updateCmsDocument = (data) => {
    return request({
        url: '/cms/adm/cmsDocument/updateCmsDocument',
        method: 'post',
        type: 'json',
        data
    })
}

// 删除文件资料
export const delCmsDocument = (data) => {
    return request({
        url: '/cms/adm/cmsDocument/delCmsDocument',
        method: 'post',
        data
    })
}